import React from 'react'

function Meeting() {
  return (
    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', height:'800px', fontSize:'20px'}}>Coming Soon...</div>
  )
}

export default Meeting